import React from "react";
import { Icon, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import { vinculationStatuses } from "./VinculationsTable";

import styled from "styled-components/macro";

const StatusIconWrapper = styled(Icon)`
  font-size: 24px;
`;

const StatusIcon = ({ status, rejectedReason }) => {
  const { t } = useTranslation("components");

  if (status === vinculationStatuses.pending) {
    return <StatusIconWrapper data-test="status-pending" type="clock-circle" />;
  }
  if (status === vinculationStatuses.linked) {
    return (
      <StatusIconWrapper
        data-test="status-linked"
        type="check-circle"
        style={{ color: "#3D64FF" }}
      />
    );
  }
  if (status === vinculationStatuses.error) {
    return (
      <StatusIconWrapper data-test="status-error" type="exclamation-circle" />
    );
  }
  if (status === vinculationStatuses.rejected) {
    return (
      <Tooltip
        placement="top"
        title={
          rejectedReason &&
          t("StatusIcon.rejectReason", { reason: rejectedReason })
        }
      >
        <StatusIconWrapper
          data-test="status-rejected"
          type="close-circle"
          style={{ color: "#ff4d4e" }}
        />
      </Tooltip>
    );
  }
  return null;
};

export default StatusIcon;
